export default class NetworkRules {
  constructor(api) {
    this.api = api;
  }
  getAll(type, value, queryParams, onSuccess, onError) {
    let params = "";
    if(queryParams){
      for (const [query, value] of Object.entries(queryParams)) {
        params += params === "" ? "?" : "&";
        params += query + "=" + value;
      }
    }
    params = params !== "" ? params + "&" : "?";
    return this.api.http_fibercloud
      .get("v1/networkrules/template" + params + "filter[" + type + "]=" + value)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getByID(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/networkrules/template/" + uuid + "?include=engineering_rule")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  create(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/networkrules/template?include=engineering_rule", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  edit(uuid, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .put(
        "v1/networkrules/template/" + uuid + "?include=engineering_rule",
        data
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  delete(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/networkrules/template/" + uuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getAllOfUser(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/networkrules/templates")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/networkRules.js